// extracted by mini-css-extract-plugin
export default {"portal":"Qrw1A__portal"};